// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UnVN","inner":"Footer_inner__1UOQI"};